import { render, staticRenderFns } from "./RefundBookingPage.vue?vue&type=template&id=5c94a57c&scoped=true&"
import script from "./RefundBookingPage.vue?vue&type=script&lang=js&"
export * from "./RefundBookingPage.vue?vue&type=script&lang=js&"
import style0 from "./RefundBookingPage.vue?vue&type=style&index=0&id=5c94a57c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c94a57c",
  null
  
)

export default component.exports